import { envDefaults } from '../_config/envDefaults';

export const jobApplyStatus = {
  bookmarked: 'BOOKMARKED',
  applied: 'APPLIED',
  interview: 'INTERVIEW',
  offered: 'OFFERED',
  hired: 'HIRED',
};

export const questionStatus = {
  already_sent: 'ALREADYSENT',
  evaluated: 'EVALUATED',
  answered: 'ANSWERED',
  assigned: 'ASSIGNED',
};

export const autoApplyStatus = {
  marked: 'AUTOAPPLYMARKED',
  applied: 'AUTOAPPLIED',
};

export const aiPlatformTypes = {
  openai: 'OPENAI',
  claudeai: 'CLOUDEAI',
};

export const socketIoEvents = {
  autoApply: 'AUTOAPPLY',
  fineTuneResume: 'RESUMEFINETUNE',
  mockInterviewQuestionRating: 'MOCKINTERVIEWQUESTIONRATING',
  mockInterviewGenerate: 'MOCKINTERVIEWGENERATE',
  emailNotification: 'EMAILNOTIFICATION',
  joinRoom: 'JOIN_ROOM',
  userDisconnected: 'USER_DISCONNECTED',
  disconnect: 'disconnect',
};

export const queueStatusTypes = {
  started: 'STARTED',
  completed: 'COMPLETED',
  resolved: 'RESOLVED',
  sent: 'SENT',
};

export const referralStatus = {
  pending: 'pending',
  accepted: 'accepted',
  withdrawn: 'withdrawn',
  archived: 'archived',
  inactive: 'inactive',
  escalated: 'escalated',
  referred: 'referred',
};

export const platformRoles = {
  admin: 'ADMIN',
  manager: 'MANAGER',
  user: 'USER',
};

export const platformPermissions = {
  // User management
  viewUsers: 'VIEW_USERS',
  createUser: 'CREATE_USER',
  updateUser: 'UPDATE_USER',
  deleteUser: 'DELETE_USER',

  // Contact Clues
  viewContacts: 'VIEW_CONTACTS',
  createContact: 'CREATE_CONTACT',
  updateContact: 'UPDATE_CONTACT',
  deleteContact: 'DELETE_CONTACT',

  // Company management
  viewCompanies: 'VIEW_COMPANIES',
  createCompany: 'CREATE_COMPANY',
  updateCompany: 'UPDATE_COMPANY',
  deleteCompany: 'DELETE_COMPANY',

  // Company sector management
  viewCompanySectors: 'VIEW_COMPANY_SECTORS',
  createCompanySector: 'CREATE_COMPANY_SECTOR',

  // Organisation management
  viewOrganisations: 'VIEW_ORGANISATIONS',
  createOrganisation: 'CREATE_ORGANISATION',
  updateOrganisation: 'UPDATE_ORGANISATION',
  deleteOrganisation: 'DELETE_ORGANISATION',
};

export const platformRolesAndPermissions = [
  {
    name: 'MANAGER',
    permissions: [
      platformPermissions.viewUsers,
      platformPermissions.viewContacts,
      platformPermissions.createContact,
      platformPermissions.updateContact,
      platformPermissions.deleteContact,
      platformPermissions.viewCompanies,
      platformPermissions.updateCompany,
    ],
    isSystem: true,
  },
  {
    name: 'USER',
    permissions: [
      platformPermissions.viewContacts,
      platformPermissions.createContact,
      platformPermissions.updateContact,
      platformPermissions.viewCompanies,
      platformPermissions.createCompany,
    ],
    isSystem: true,
  },
];

export const microsoftLoginScopes = ['User.read', 'openid', 'profile', 'email', 'Mail.Read', 'Mail.Send', 'offline_access'];

export const msalConfig = {
  auth: {
    clientId: envDefaults.microsoftClientId,
    authority: `https://login.microsoftonline.com/common`,
    redirectUri: envDefaults.microsoftRedirectUri,
  },
};
